import React from 'react';
import { NavLink } from 'react-router-dom';
import Message from 'Components/Modal/Message';
import { closeModal } from 'Store/actions';
import { useDispatch } from 'react-redux';

const KVKKModal = props => {
  const dispatch = useDispatch();
  /*const buttonConfig = {
    primary: {
      label: 'Tamam',
      onClick: props.onPrimaryButtonClick
    }
  };*/

  return (
    <Message type="none">
      <p>{ 'KVKK Aydınlatma metni güncellenmiştir, okumak için lütfen ' }
        <NavLink className="modal-kvkk" to='/KVKK' onClick={ () => dispatch(closeModal('KVKKModal')) }>
          tıkla
        </NavLink>
      </p>
    </Message>
  );
};


export default KVKKModal;
